/* eslint-disable max-len */
/**
 * IDE Tutorial chapters (PRJ-06 / LLD UC 09). 8 chapters covering key
 * mSTEM IDE flows. Authored in Vietnamese per Phase 1 D-11 locale default.
 *
 * Total: 8 chapters × 4 sections each = 32 SVG illustrations.
 *
 * Wave 3a (03-07a): 8 metadata stubs.
 * Wave 3b (03-07b): this file — full content + 32 SVG imports.
 *
 * eslint-disable max-len: section body strings are Vietnamese tutorial
 * content that should not be artificially broken mid-sentence for line length.
 */
import ide01Menubar from '../../../components/mstem-tutorial-modal/illustrations/ide-01-overview-menubar.svg';
import ide01Workspace from '../../../components/mstem-tutorial-modal/illustrations/ide-01-overview-workspace.svg';
import ide01Stage from '../../../components/mstem-tutorial-modal/illustrations/ide-01-overview-stage.svg';
import ide01Spritelist from '../../../components/mstem-tutorial-modal/illustrations/ide-01-overview-sprite-list.svg';
import ide02FileMenu from '../../../components/mstem-tutorial-modal/illustrations/ide-02-file-menu-new.svg';
import ide02Modal from '../../../components/mstem-tutorial-modal/illustrations/ide-02-modal-form.svg';
import ide02Fields from '../../../components/mstem-tutorial-modal/illustrations/ide-02-fill-fields.svg';
import ide02Success from '../../../components/mstem-tutorial-modal/illustrations/ide-02-success-workspace.svg';
import ide03Palette from '../../../components/mstem-tutorial-modal/illustrations/ide-03-block-palette.svg';
import ide03Drag from '../../../components/mstem-tutorial-modal/illustrations/ide-03-drag-arrow.svg';
import ide03Snap from '../../../components/mstem-tutorial-modal/illustrations/ide-03-snap-together.svg';
import ide03Run from '../../../components/mstem-tutorial-modal/illustrations/ide-03-green-flag-run.svg';
import ide04Ctrl from '../../../components/mstem-tutorial-modal/illustrations/ide-04-ctrl-s-shortcut.svg';
import ide04SaveModal from '../../../components/mstem-tutorial-modal/illustrations/ide-04-save-modal.svg';
import ide04OpenTable from '../../../components/mstem-tutorial-modal/illustrations/ide-04-open-modal-table.svg';
import ide04Load from '../../../components/mstem-tutorial-modal/illustrations/ide-04-load-project.svg';
import ide05Add from '../../../components/mstem-tutorial-modal/illustrations/ide-05-add-sprite-button.svg';
import ide05Library from '../../../components/mstem-tutorial-modal/illustrations/ide-05-sprite-library.svg';
import ide05Tab from '../../../components/mstem-tutorial-modal/illustrations/ide-05-costume-tab.svg';
import ide05List from '../../../components/mstem-tutorial-modal/illustrations/ide-05-costume-list.svg';
import ide06Cat from '../../../components/mstem-tutorial-modal/illustrations/ide-06-robot-category.svg';
import ide06Motor from '../../../components/mstem-tutorial-modal/illustrations/ide-06-motor-block.svg';
import ide06Sensor from '../../../components/mstem-tutorial-modal/illustrations/ide-06-sensor-block.svg';
import ide06Upload from '../../../components/mstem-tutorial-modal/illustrations/ide-06-upload-firmware.svg';
import ide07Share from '../../../components/mstem-tutorial-modal/illustrations/ide-07-file-share.svg';
import ide07Form from '../../../components/mstem-tutorial-modal/illustrations/ide-07-share-form.svg';
import ide07Link from '../../../components/mstem-tutorial-modal/illustrations/ide-07-share-link.svg';
import ide07Received from '../../../components/mstem-tutorial-modal/illustrations/ide-07-shared-with-me.svg';
import ide08Cog from '../../../components/mstem-tutorial-modal/illustrations/ide-08-settings-cog.svg';
import ide08Theme from '../../../components/mstem-tutorial-modal/illustrations/ide-08-theme-manager.svg';
import ide08Globe from '../../../components/mstem-tutorial-modal/illustrations/ide-08-globe-icon.svg';
import ide08Toggle from '../../../components/mstem-tutorial-modal/illustrations/ide-08-vn-en-toggle.svg';

const IDE_CHAPTERS = [
    {
        id: 'ide-01-overview',
        title: 'Tổng quan giao diện',
        sections: [
            {
                heading: 'Menu bar trên cùng',
                body: 'Phía trên cùng của IDE là thanh menu chứa các nút điều khiển chính: Tạo dự án mới, Mở dự án, Lưu dự án, Chia sẻ và Trợ giúp. Logo mSTEM nằm bên trái xác định danh tính ứng dụng.',
                illustration: ide01Menubar,
                illustrationAlt: 'Sơ đồ menu bar mSTEM với các nút chính'
            },
            {
                heading: 'Workspace ở giữa',
                body: 'Không gian làm việc chính là nơi bạn kéo thả các khối lệnh để xây dựng chương trình. Bên trái là bảng các category block (Motion, Looks, Sound, Events, Control, Sensing, Operators, Variables, My Blocks, Robot, SmartHome), bên phải là khu vực workspace để ráp block.',
                illustration: ide01Workspace,
                illustrationAlt: 'Workspace với block palette và khu vực làm việc'
            },
            {
                heading: 'Stage ở góc phải',
                body: 'Stage hiển thị kết quả khi chương trình chạy. Sprite (nhân vật) sẽ di chuyển và thực hiện hành động theo các block bạn lập trình. Nút cờ xanh chạy chương trình, nút stop màu đỏ dừng lại.',
                illustration: ide01Stage,
                illustrationAlt: 'Stage với sprite mèo Scratch mặc định và 2 nút điều khiển'
            },
            {
                heading: 'Danh sách sprite phía dưới',
                body: 'Bên dưới stage là danh sách sprite của dự án. Mỗi sprite có thể có nhiều costume (hình dạng) khác nhau. Click vào sprite để chọn — block bạn ráp sẽ áp dụng cho sprite đang chọn.',
                illustration: ide01Spritelist,
                illustrationAlt: 'Sprite list panel với nhiều sprite items + nút thêm'
            }
        ]
    },
    {
        id: 'ide-02-create-project',
        title: 'Tạo dự án đầu tiên',
        sections: [
            {
                heading: 'Mở menu File → Tạo dự án mới',
                body: 'Click vào menu "File" trên menu bar, chọn "Tạo dự án mới" (phím tắt Ctrl+N). Đây là cách bắt đầu một dự án trống mới với cấu hình thiết bị tùy chọn.',
                illustration: ide02FileMenu,
                illustrationAlt: 'File menu dropdown highlighting Tạo dự án mới'
            },
            {
                heading: 'Điền form thông tin',
                body: 'Modal hiện ra với 3 trường: Tên dự án (bắt buộc), Loại thiết bị kết nối (Robot mSTEM / Kit SmartHome / Không kết nối), Mô tả (tùy chọn). Điền đầy đủ trước khi xác nhận.',
                illustration: ide02Modal,
                illustrationAlt: 'NewProjectModal mockup với 3 form fields trống'
            },
            {
                heading: 'Ví dụ điền form',
                body: 'Ví dụ: Tên dự án "Robot Tự Đi", Loại thiết bị "Robot mSTEM", Mô tả "Robot điều khiển động cơ di chuyển". Sau khi điền đầy đủ, click nút "Xác nhận tạo" màu xanh ở dưới cùng modal.',
                illustration: ide02Fields,
                illustrationAlt: 'Form đã điền ví dụ Robot Tự Đi với border xanh validation thành công'
            },
            {
                heading: 'Workspace hiện ra',
                body: 'Sau khi xác nhận, workspace xuất hiện với sprite mèo mặc định ở stage. Tên dự án bạn vừa nhập hiện ở header. Bạn đã sẵn sàng để kéo thả block và bắt đầu lập trình.',
                illustration: ide02Success,
                illustrationAlt: 'Workspace hiện ra với cat sprite và project title ở header'
            }
        ]
    },
    {
        id: 'ide-03-drag-blocks',
        title: 'Kéo thả block & chạy',
        sections: [
            {
                heading: 'Chọn category block',
                body: 'Bên trái workspace có 10+ category block. Click vào "Motion" (màu xanh dương) để xem các block điều khiển chuyển động: di chuyển N bước, quay phải, quay trái, đi tới x,y, trỏ tới hướng.',
                illustration: ide03Palette,
                illustrationAlt: 'Block palette với category Motion đã chọn và các block bên trong'
            },
            {
                heading: 'Kéo block vào workspace',
                body: 'Click giữ chuột trên block "di chuyển 10 bước", kéo sang khu vực workspace bên phải, thả ra. Block sẽ neo lại trong workspace và sẵn sàng để kết nối với block khác.',
                illustration: ide03Drag,
                illustrationAlt: 'Block được kéo từ palette sang workspace với mũi tên hướng dẫn'
            },
            {
                heading: 'Ráp block vào nhau',
                body: 'Block có đầu nối giống lego. Kéo block "quay phải 15 độ" và ráp vào dưới block "di chuyển 10 bước". Các block sẽ dính chặt vào nhau thành 1 stack chương trình.',
                illustration: ide03Snap,
                illustrationAlt: 'Nhiều block đã được ráp vào nhau thành stack chương trình'
            },
            {
                heading: 'Chạy chương trình',
                body: 'Thêm block "khi cờ xanh được nhấn" (Events category) lên đầu stack. Click nút cờ xanh trên stage để chạy. Sprite mèo sẽ di chuyển và quay theo các block bạn đã ráp. Nút màu đỏ để dừng.',
                illustration: ide03Run,
                illustrationAlt: 'Cờ xanh highlighted + sprite đã di chuyển trên stage'
            }
        ]
    },
    {
        id: 'ide-04-save-open',
        title: 'Lưu và mở dự án',
        sections: [
            {
                heading: 'Lưu nhanh với Ctrl+S',
                body: 'Nhấn Ctrl+S để lưu nhanh dự án đang làm. Nếu là lần đầu lưu, modal sẽ hỏi tên dự án. Lần sau Ctrl+S chỉ cập nhật phiên bản mới nhất, không hỏi lại tên.',
                illustration: ide04Ctrl,
                illustrationAlt: 'Bàn phím với phím Ctrl và S được highlight'
            },
            {
                heading: 'Modal lưu lần đầu',
                body: 'Modal "Lưu dự án" có 1 trường Tên dự án (mặc định lấy từ project title hiện tại). Nhập tên mong muốn, click "Lưu". Dự án được lưu vào trình duyệt local (localStorage) để dùng lại sau.',
                illustration: ide04SaveModal,
                illustrationAlt: 'SaveProjectModal mockup với trường Tên dự án và nút Lưu'
            },
            {
                heading: 'Mở dự án đã lưu',
                body: 'File → "Mở dự án có sẵn". Modal hiện ra với bảng danh sách dự án bạn đã lưu cộng thêm 5 dự án mẫu MBF. Có thanh tìm kiếm để lọc theo tên hoặc mô tả nhanh chóng.',
                illustration: ide04OpenTable,
                illustrationAlt: 'OpenProjectModal với bảng danh sách dự án + search'
            },
            {
                heading: 'Tải dự án về workspace',
                body: 'Click nút "Tải" trên dòng dự án bạn muốn mở. Workspace sẽ được khôi phục với block đã lưu, sprite, costume và stage state. Toast xác nhận "Đã tải dự án [Tên]" hiện ra ở góc dưới.',
                illustration: ide04Load,
                illustrationAlt: 'Dự án đã chọn + workspace khôi phục với block stack'
            }
        ]
    },
    {
        id: 'ide-05-sprite-costume',
        title: 'Quản lý sprite & costume',
        sections: [
            {
                heading: 'Thêm sprite mới',
                body: 'Phía dưới stage có nút "+" để thêm sprite. Click vào nó để mở sprite library với hàng trăm sprite có sẵn (animal, person, vehicle, fantasy, MBF robot models).',
                illustration: ide05Add,
                illustrationAlt: 'Sprite library trigger button + dấu cộng nổi bật'
            },
            {
                heading: 'Chọn từ sprite library',
                body: 'Sprite library hiển thị grid các sprite mẫu. Click vào sprite muốn dùng → nó sẽ xuất hiện trong sprite list của dự án. Mỗi sprite kèm theo costume mặc định và sẵn sàng để lập trình.',
                illustration: ide05Library,
                illustrationAlt: 'Sprite library grid với nhiều sample sprite'
            },
            {
                heading: 'Đổi costume sprite',
                body: 'Click tab "Costumes" trên top workspace để vào editor. Sprite có thể có nhiều costume khác nhau (ví dụ: mèo bình thường, mèo nhảy, mèo ngồi). Trong tab này bạn cũng có thể vẽ thêm costume mới.',
                illustration: ide05Tab,
                illustrationAlt: 'Costume tab editor view với 2 costume preview'
            },
            {
                heading: 'Switch costume bằng block',
                body: 'Trong Looks category có block "đổi costume sang [name]". Kết hợp với block "đợi 0.5 giây" trong vòng lặp forever để tạo animation đơn giản (mèo đi: chuyển luân phiên giữa 2 costume).',
                illustration: ide05List,
                illustrationAlt: 'Block stack tạo animation + sprite mèo nhảy đi trên stage'
            }
        ]
    },
    {
        id: 'ide-06-robot-blocks',
        title: 'Sử dụng block Robot',
        sections: [
            {
                heading: 'Mở category Robot',
                body: 'Sau khi chọn thiết bị "MBF Robot v1" từ Device Library, block palette có thêm category "Robot" màu cyan riêng biệt. Đây là nơi chứa tất cả block điều khiển động cơ, cảm biến và LED của robot.',
                illustration: ide06Cat,
                illustrationAlt: 'Block palette với category Robot mới xuất hiện và được highlight'
            },
            {
                heading: 'Block điều khiển động cơ',
                body: 'Block "chạy động cơ L298N" cho phép set tốc độ và hướng cho motor trái/phải của robot. Ví dụ: tốc độ 150 đi thẳng, tốc độ -150 đi lùi, tốc độ 0 dừng. Kết hợp 2 motor để xoay tại chỗ.',
                illustration: ide06Motor,
                illustrationAlt: 'Block điều khiển động cơ L298N + sơ đồ robot di chuyển'
            },
            {
                heading: 'Block đọc cảm biến',
                body: 'Block "đọc cảm biến sharpIR" trả về giá trị 0 (đen) hoặc 1 (trắng). Kết hợp với block "if" để robot tự động bám theo đường vạch đen — đây là bài tập STEM kinh điển cho học viên mới bắt đầu.',
                illustration: ide06Sensor,
                illustrationAlt: 'Block sensor sharpIR + sơ đồ vạch đen trắng'
            },
            {
                heading: 'Upload chương trình lên robot',
                body: 'Khi xong code, click "Upload Firmware" trên menu bar. Wizard 3 bước sẽ hướng dẫn chọn robot + chọn version firmware + xem progress upload. Sau khi upload thành công, robot sẽ tự động chạy chương trình bạn đã lập trình.',
                illustration: ide06Upload,
                illustrationAlt: 'Sơ đồ máy tính kết nối USB với robot + wizard 3 bước upload'
            }
        ]
    },
    {
        id: 'ide-07-share',
        title: 'Chia sẻ dự án',
        sections: [
            {
                heading: 'Mở menu Chia sẻ',
                body: 'File → "Chia sẻ dự án" (phím tắt Ctrl+Shift+S). Modal chia sẻ hiện ra cho phép bạn gửi dự án cho giáo viên, lớp học cụ thể, hoặc công khai với cộng đồng MBF.',
                illustration: ide07Share,
                illustrationAlt: 'File menu highlighting mục Chia sẻ dự án'
            },
            {
                heading: 'Điền form chia sẻ',
                body: 'Form có 5 trường: Tên dự án (tự động lấy), Đối tượng (giáo viên / lớp / cộng đồng MBF), Quyền truy cập (Xem hoặc Sao chép), Lời nhắn (tùy chọn). Sau khi điền đầy đủ, click "Xác nhận chia sẻ".',
                illustration: ide07Form,
                illustrationAlt: 'ShareProjectModal step 1 với form đã điền'
            },
            {
                heading: 'Sao chép link chia sẻ',
                body: 'Sau khi xác nhận, modal hiện link mock "https://mstem.mobifone.vn/share/[id]". Click "Copy" để sao chép vào clipboard rồi gửi link cho người nhận qua chat, email hoặc tin nhắn. Hiện cũng badge cho biết quyền truy cập đã set.',
                illustration: ide07Link,
                illustrationAlt: 'ShareProjectModal step 2 với link reveal và nút Copy'
            },
            {
                heading: 'Xem dự án người khác chia sẻ',
                body: 'File → "Dự án được chia sẻ với tôi" mở bảng danh sách dự án được người khác chia sẻ. Có thể tìm kiếm, lọc theo nguồn (giáo viên / lớp học / cộng đồng). Mỗi dòng có nút "Xem" (read-only) và "Lưu copy" (nếu quyền cho phép).',
                illustration: ide07Received,
                illustrationAlt: 'SharedProjectsModal với bảng danh sách + filter dropdown'
            }
        ]
    },
    {
        id: 'ide-08-theme-locale',
        title: 'Đổi giao diện & ngôn ngữ',
        sections: [
            {
                heading: 'Mở Theme Manager',
                body: 'Click icon cog (bánh răng) trên menu bar bên phải. Dropdown hiện ra với 2 mục: "Quản lý màu sắc phông nền IDE" để mở Theme Manager + "Device manager" để chọn robot.',
                illustration: ide08Cog,
                illustrationAlt: 'Icon cog trong menu bar với dropdown mở'
            },
            {
                heading: 'Chọn theme',
                body: 'Theme Manager hiện 3 theme có sẵn: Sáng (mặc định, navy + white), Tối (dark mode), Xanh cyan (accent). Click vào preview card để apply ngay tức thì, không cần reload trang. Toàn bộ menu, modal, sidebar đổi màu theo.',
                illustration: ide08Theme,
                illustrationAlt: 'ThemeManagerModal với 3 theme preview cards'
            },
            {
                heading: 'Đổi ngôn ngữ',
                body: 'Click icon globe (quả địa cầu) trên menu bar → dropdown hiện 2 lựa chọn VN và EN. mSTEM IDE mặc định là tiếng Việt; chọn "English" nếu bạn muốn dùng tiếng Anh hoặc đào tạo cho học viên quốc tế.',
                illustration: ide08Globe,
                illustrationAlt: 'Icon globe + dropdown với 2 ngôn ngữ VN/EN'
            },
            {
                heading: 'So sánh VN và EN',
                body: 'Toàn bộ menu, modal, label, tooltip sẽ chuyển ngữ ngay không cần reload. Riêng block category names (Motion, Looks, Sound, Events, Control...) giữ nguyên tiếng Anh theo Scratch convention — quy ước này giúp học viên đọc được tài liệu Scratch quốc tế.',
                illustration: ide08Toggle,
                illustrationAlt: 'So sánh giao diện VN và EN side-by-side'
            }
        ]
    }
];

export default IDE_CHAPTERS;
